<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('deleteScoreBySession.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('deleteScoreBySession.pageTitle'), active: true }
        ]"
      />
    </div>

    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button
            outline
            color="info"
            @click="$router.push({ name: 'student-score-delete-by-session-create' })"
          >
            {{ $t('deleteScoreBySession.deleteAction') }}
          </ts-button>
          <ts-input
            v-model="search"
            :placeholder="$t('search')"
            style="width: 250px"
            class="inline-block"
          />
        </div>
      </ts-card-wrapper>

      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.student_name }}</td>
            <td>{{ record.main_program }}</td>
            <td>{{ record.sub_program }}</td>
            <td>{{ record.grade_name }}</td>
            <td>{{ record.class_name }}</td>
            <td>{{ record.session_name }}</td>
            <td>{{ record.deleted_by_name || record.deleted_by }}</td>
            <td>{{ record.deleted_date }}</td>
          </template>
        </ts-table>
      </div>

      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'studentScoreDeleteBySessionIndex',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('studentScoreDeleteBySession', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.studentScoreDeleteBySession.search
      },
      set(newValue) {
        this.$store.commit('studentScoreDeleteBySession/SET_SEARCH', newValue)
        this.$store.commit('studentScoreDeleteBySession/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('deleteScoreBySession.student') },
        { name: this.$t('deleteScoreBySession.mainProgram') },
        { name: this.$t('deleteScoreBySession.subProgram') },
        { name: this.$t('deleteScoreBySession.grade') },
        { name: this.$t('deleteScoreBySession.classroom') },
        { name: this.$t('deleteScoreBySession.session') },
        { name: this.$t('deleteScoreBySession.deletedBy') },
        { name: this.$t('deleteScoreBySession.deletedDate') }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('studentScoreDeleteBySession/fetch', attributes)
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    search: debounce(function () {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('studentScoreDeleteBySession/RESET_STATE')
    next()
  }
}
</script>
